import React from 'react';
import styled from 'styled-components';
import ServicePage from './ServicePage';
import { faCode } from '@fortawesome/free-solid-svg-icons';
import SoftwareImage from "../assets/software.webp"

const SectionTitle = styled.h3`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;
  text-align: center;
  margin: ${props => props.margin || '0 0 20px 0'};
`;

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 40px;
  
  @media (max-width: 768px) {
    justify-content: space-around;
  }
  
  @media (max-width: 576px) {
    justify-content: center;
  }
`;

const SoftwareCard = styled.div`
  flex: 0 0 43%;
  margin-bottom: 30px;
  padding: 30px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  
  @media (max-width: 968px) {
    flex: 0 0 90%;
  }
  
  @media (max-width: 576px) {
    flex: 0 0 85%;
  }
  
  h4 {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 15px;
    color: #4a90e2;
  }
  
  p {
    font-size: 15px;
    color: #666;
    line-height: 1.6;
  }
`;

const TechContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 30px;
  
  @media (max-width: 576px) {
    gap: 15px;
  }
`;

const TechTag = styled.div`
  padding: 15px 25px;
  background-color: #fff;
  border-radius: 30px;
  box-shadow: 0 3px 10px rgba(0,0,0,0.05);
  font-size: 14px;
  font-weight: 500;
  
  @media (max-width: 576px) {
    padding: 12px 20px;
    font-size: 13px;
  }
`;

const SoftwareDevelopmentPage = () => {
  const features = [
    'Custom software solutions tailored to your business needs',
    'Full-cycle development from concept to deployment',
    'Agile development methodology for faster delivery',
    'Scalable architecture for future growth',
    'Comprehensive testing and quality assurance',
    'Ongoing maintenance and support'
  ];

  const additionalContent = (
    <div>
      <SectionTitle>
        Our Software Development Process
      </SectionTitle>
      <CardContainer>
        <SoftwareCard>
          <h4>Requirements Analysis</h4>
          <p>
            We work closely with you to understand your business needs, user requirements, and project goals to create a comprehensive software specification that guides our development process.
          </p>
        </SoftwareCard>
        <SoftwareCard>
          <h4>Architecture & Design</h4>
          <p>
            Our architects design scalable, maintainable software architectures that align with your business objectives and technical requirements, ensuring a solid foundation for development.
          </p>
        </SoftwareCard>
        <SoftwareCard>
          <h4>Development & Testing</h4>
          <p>
            We follow agile development methodologies with continuous integration and testing to deliver high-quality, bug-free software that meets your specifications and performance requirements.
          </p>
        </SoftwareCard>
        <SoftwareCard>
          <h4>Deployment & Maintenance</h4>
          <p>
            We handle seamless deployment of your software and provide ongoing maintenance and support services to ensure your application remains secure, up-to-date, and performs optimally.
          </p>
        </SoftwareCard>
      </CardContainer>
      
      <SectionTitle margin="50px 0 20px">
        Technologies We Use
      </SectionTitle>
      <TechContainer>
        <TechTag>Java</TechTag>
        <TechTag>Python</TechTag>
        <TechTag>C#/.NET</TechTag>
        <TechTag>Node.js</TechTag>
        <TechTag>SQL/NoSQL</TechTag>
        <TechTag>Docker</TechTag>
        <TechTag>Kubernetes</TechTag>
        <TechTag>AWS/Azure</TechTag>
      </TechContainer>
    </div>
  );

  return (
    <ServicePage
      icon={faCode}
      title="Software Development"
      subtitle="Custom software solutions designed to streamline your business processes, enhance productivity, and drive growth."
      description={["At Zenitech Solutions, our Software Development services are designed to turn your vision into powerful, customized digital solutions that solve real business challenges. We combine deep technical expertise with agile development practices to build scalable, secure, and high-performance applications tailored to your goals.",

        "Whether you need robust enterprise platforms, sleek mobile and web apps, or specialized tools to streamline operations, our team delivers software that is future-ready, user-centric, and aligned with your growth strategy. We focus on creating solutions that not only meet your current needs but also evolve with your business.",
        
        "From concept to deployment — and beyond — we partner with you at every stage to ensure quality, innovation, and long-term value. With Zenitech Solutions, you're not just investing in code; you're investing in technology that empowers progress."]}
      features={features}
      imagePath={SoftwareImage}
      additionalContent={additionalContent}
      featuresDesciption="Our Mobile App Development service delivers high-quality, user-friendly applications for iOS and Android platforms. We combine cutting-edge technology with intuitive design to create mobile experiences that delight users and drive business growth. From concept to deployment, we handle every aspect of the app development lifecycle."
      metaTitle="Software Development Services"
      metaDescription="Our Software Development services provide comprehensive solutions for your software needs. From concept to deployment, we deliver high-quality, user-centric applications that align with your goals."
    />
  );
};

export default SoftwareDevelopmentPage;